import { createMichelinBrandThemeOptions } from "./createMichelinBrandThemeOptions";

const lightMichelinThemeOptions = createMichelinBrandThemeOptions('light');

export {
  lightMichelinThemeOptions,
};
